{
 "name": "0_plant_flower_5",
 "bin": "0_plant_flower_5.bin",
 "nodes": [
  {"name": "", "parent": -1, "t": [0,0,0], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "Fbx_Root", "parent": 0, "t": [0,0,0], "q": [-0.7071068,0,0,0.7071068], "s": [0.0254,0.0254,0.0254]},
  {"name": "Producer Perspective", "parent": 0, "t": [0,0.713,2.875], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Top", "parent": 0, "t": [0,40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Bottom", "parent": 0, "t": [0,-40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Front", "parent": 0, "t": [0,0,40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Back", "parent": 0, "t": [0,0,-40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Right", "parent": 0, "t": [40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Left", "parent": 0, "t": [-40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Camera Switcher", "parent": 0, "t": [0,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "0_plant_flower_5", "parent": 1, "t": [-1.164417,-3.211856,0.229342], "q": [0,-0,-7.450583e-09,1], "s": [1,1,1]},
  {"name": "", "parent": 10, "t": [2.129035,4.750031,0], "q": [0,-0,-0.06975647,0.9975641], "s": [1,1,1]},
  {"name": "0_plant_flower01", "parent": 10, "t": [1.414772,6.598842,-0.229342], "q": [-0.005167508,-0.6931489,-0.018862,0.720529], "s": [1,1,1]},
  {"name": "0_plant_flower5", "parent": 10, "t": [1.414772,6.598842,-0.229342], "q": [-0.005167508,-0.6931489,-0.018862,0.720529], "s": [1,1,1]},
  {"name": "Capsule02", "parent": 12, "t": [-2.861023e-06,-7.511955,1.430511e-06], "q": [-5.338506e-08,-0.7071067,-0.7071069,-5.338508e-08], "s": [1,1,0.6658086]},
  {"name": "Capsule01", "parent": 13, "t": [-2.861023e-06,-7.511955,1.430511e-06], "q": [-5.338506e-08,-0.7071067,-0.7071069,-5.338508e-08], "s": [1,1,0.6658086]}
 ],
 "parts": [
  {"node": 14, "vertexCount": 144, "posOffset": 0, "nrmOffset": 1728, "uvOffset": 3456, "material": "0_plant_flower1", "color": [0.2157,0.6118,0,1], "texture": "0_plant_flower_5.png"},
  {"node": 15, "vertexCount": 144, "posOffset": 4608, "nrmOffset": 6336, "uvOffset": 8064, "material": "0_plant_flower1", "color": [0.2157,0.6118,0,1], "texture": "0_plant_flower_5.png"}
 ],
 "anims": [
  {"name": "die", "duration": 0.8, "fps": 30, "frames": 25, "offset": 9216},
  {"name": "grow", "duration": 3.3, "fps": 30, "frames": 100, "offset": 25216},
  {"name": "idle", "duration": 0.8, "fps": 30, "frames": 25, "offset": 89216},
  {"name": "pick", "duration": 0.96667, "fps": 30, "frames": 30, "offset": 105216}
 ]
}
